/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';
import { AiOutlineCheckCircle } from 'react-icons/ai';

export const Container = styled.label`
  background: white;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 100%;
  display: flex;
  align-items: center;

  color: ${({ theme }) => theme.colors.gray};
  svg {
    color: ${({ theme }) => theme.colors.gray};
    path {
      &.b {
        color: ${({ theme }) => theme.colors.gray};
        fill: ${({ theme }) => theme.colors.gray};
      }
    }
  }

  padding: 8px 12px 8px 12px;
  height: 50px;
  transition: border-color 0.5s, color 0.5s;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #dc3545;
      svg {
        color: #dc3545;
        path {
          &.b {
            color: #dc3545;
            fill: #dc3545;
          }
        }
      }
    `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: ${props.borderHighlightColor};
      svg {
        color: ${props.borderHighlightColor} !important;

        path {
          &.b {
            color: ${props.borderHighlightColor} !important;
            fill: ${props.borderHighlightColor} !important;
          }
        }
      }
    `}

    ${(props) =>
    props.disabled &&
    css`
      border: 1px solid #c1c1c1;
      background-color: #eeeeee;

      svg {
        path {
          &.a {
            fill: #eeeeee;
          }
        }
      }
    `}

    svg:first-child {
    margin-right: 7px;
  }

  svg:last-child {
    margin-left: 7px;
  }

  div {
    display: flex;
    flex: 1;
    position: relative;
    flex-direction: column;

    span {
      color: ${({ theme }) => theme.colors.gray};
    }

    input {
      width: 100%;
      flex: 1;
      background: transparent;
      border: 0;
      color: ${({ theme }) => theme.colors.gray};
      outline: none !important;
      padding: 0;
      margin-top: -5px;

      &::placeholder {
        color: #666360;
      }
    }
    input[type='number'] {
      -moz-appearance: textfield;
      -webkit-appearance: none;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -moz-appearance: textfield;
      -webkit-appearance: none;
    }
  }
`;

export const ErrorText = styled.span`
  color: #dc3545;
`;

export const LabelText = styled.span`
  color: ${({ theme }) => theme.colors.mediumGray};

  position: absolute;
  padding-top: 2px;

  transition: font-size 1s;
  transform: translateY(-3px);

  font-weight: 400;
  font-size: ${({ labelActivated }) =>
    labelActivated ? '0.825rem' : '0.975rem'};

  @media (max-width: 374px) {
    font-size: 0.8rem !important;
  }

  ${(props) =>
    props.labelActivated &&
    css`
      position: initial;
      transform: translateY(0);
    `}
`;

export const CorrectIcon = styled(AiOutlineCheckCircle)`
  color: #49c4d8 !important;
`;

export const Eye = styled.img`
  width: 30px;
  line-height: 1.75;
  font-size: 1.5rem;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  user-select: none;
  margin-left: 13px;
  margin-right: 3px;

  color: ${({ theme }) => theme.colors.gray};
`;
